var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-section-title',[_vm._v("#"+_vm._s(_vm.$t("homepage.whoami.title"))+"'")]),_c('article',{staticClass:"mt-5"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t("homepage.whoami.content"))}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }